module.exports = __webpack_public_path__ + "img/134.3.892ad924.png";